import gql from 'graphql-tag';

import fragments from './fragments';

export const activeProductsCheck = gql`
  query ActiveProductsCheck($productsFilter: activeProductsCheckInput!, $includeEnterpriseSpecials: Boolean = false) {
    activeProductsCheck(filter: $productsFilter, includeEnterpriseSpecials: $includeEnterpriseSpecials) {
      _id
      medicalSpecialPrices
      medicalPrices
      recSpecialPrices
      wholesalePrices
      recPrices
      Options
      limitsPerCustomer {
        key
        value
      }
      manualInventory {
        option
        inventory
      }
      Name
      special
      specialData {
        bogoSpecials {
          bogoConditionLogicOperator
          bogoConditions {
            _id
            brandName
            categoryName
            productGroup
            productId
            quantity
            weight
            weightOperator
          }
          bogoRewardLogicOperator
          bogoRewards {
            _id
            brandName
            categoryName
            dollarDiscount
            productGroup
            productId
            percentDiscount
            quantity
            targetPrice
            weight
          }
          discountBehavior
          discountToCart {
            _id
            enabled
            discountType
            value
          }
          endStamp
          excludedProducts {
            conditions {
              _id
              key
              Name
            }
            rewards {
              _id
              key
              Name
            }
          }
          isRecurring
          itemsForAPrice {
            _id
            enabled
            value
          }
          discountBundle {
            _id
            applyTo
            discountType
            enabled
            limit
            value
          }
          menuType
          recurringEndDate
          redemptionLimit
          specialId
          specialName
          totalQuantity {
            enabled
            maxQuantity
            quantity
            quantityOperator
          }
          totalWeight {
            enabled
            weight
            weightOperator
          }
          totalSpend {
            enabled
            maximumSpend
            minimumSpend
            spendOperator
          }
        }
        saleSpecials {
          discount
          menuType
          percentDiscount
          source
          sourceId
          specialId
          specialRestrictions
          stackingMode
          targetPrice
        }
      }
      POSMetaData {
        children {
          option
          quantity
          quantityAvailable
        }
      }
      bottleDepositTaxCents
    }
  }
`;

export const adminFilteredProducts = gql`
  ${fragments.adminBaseProductFragment}

  query AdminFilteredProducts($productsFilter: productsFilterInput!, $page: Int, $perPage: Int) {
    filteredProducts(filter: $productsFilter, page: $page, perPage: $perPage) {
      products {
        ...adminBaseProductFragment
        libraryProduct {
          id
          name
        }
        connectedCount
        forcedPotencyUnit
      }
      queryInfo {
        totalCount
      }
    }
  }
`;

export const adminIndividualFilteredProduct = gql`
  ${fragments.adminBaseProductFragment}

  query AdminIndividualFilteredProduct($productsFilter: productsFilterInput!, $includeTerpenes: Boolean! = false) {
    filteredProducts(filter: $productsFilter) {
      products {
        ...adminBaseProductFragment
        stockImage
        stockImageAliases
        stockImageCategory
        productTemplate
        libraryProduct {
          id
          name
        }
        terpenes @include(if: $includeTerpenes) {
          id
          terpeneId
          value
          unit
          unitSymbol
          libraryTerpene {
            name
          }
        }
        cannabinoidsV2 {
          value
          unit
          cannabinoidId
          cannabinoid {
            name
          }
        }
        connectedCount
        forcedPotencyUnit

        connectedByUser {
          firstName
          lastName
          fullName
        }
        updatedByUser {
          firstName
          lastName
          fullName
        }
        updatedByAdminAt
      }
      queryInfo {
        totalCount
      }
    }
  }
`;

export const matchingProducts = gql`
  query MatchingProducts(
    $dispensaryIds: [String]
    $limit: Int
    $name: String
    $productLibraryState: String
    $bypassOnlineThresholds: Boolean
  ) {
    matchingProducts(
      dispensaryIds: $dispensaryIds
      limit: $limit
      name: $name
      productLibraryState: $productLibraryState
      bypassOnlineThresholds: $bypassOnlineThresholds
    ) {
      id
      _id
      Name
      brand {
        id
        name
      }
      brandName
      type
      strainType
      THC
      THCContent {
        unit
        range
      }
      CBD
      CBDContent {
        unit
        range
      }
      Image
      recPrices
    }
  }
`;

export const bulkLibraryProductUpdateStatus = gql`
  query BulkLibraryProductUpdateStatus($jobId: String) {
    bulkLibraryProductUpdateStatus(jobId: $jobId) {
      meta {
        status
      }
    }
  }
`;
